import { render, staticRenderFns } from "./ChangeSerialNumber.vue?vue&type=template&id=28315a54&"
import script from "./ChangeSerialNumber.vue?vue&type=script&lang=js&"
export * from "./ChangeSerialNumber.vue?vue&type=script&lang=js&"
import style0 from "./ChangeSerialNumber.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports